/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-09 15:34:26
 */
export default {
  lang: "斯瓦希里",
  common: {
    name1: "Tengeneza Kadi",
    name2: "Orodha ya Cheo",
    name3: "Shiriki na Upate Likes",
    name4: "Una Likes XX",
    name5: "Wewe ndiye x wa juu sasa, Endelea",
    name6: "Pata Likes Zaidi",
    name7: "Tuma maelezo yako",
    name8: "Jina",
    name9: "Simu",
    name10: "Nchi",
    name11: "kuokoa",
    name12: "",
    name13:"Andika Baraka Yako mwenyewe Kwanza",
    name14:"Imepewa herufi 230",
    name15:"Usisahau kuwasilisha maelezo yako ili kushinda zawadi",
    name16:"1. Andika Salamu kwa rafiki zako na ushare ili kupata likes",
    name17:"2. Ukipata likes zaidi, utashinda iPhone 12 mini ~",
    name18:"3. Ikiwa uko katika TOP 100 ， utapata zawadi moja",
    name19:"Krismasi Njema Baraka Kushinda iPhone",
    name20:"Chagua kadi moja unayopenda",
    name21:"Kichwa",
    name22:"Haraka",
  },
  rules: {
    name1: "iPhone 12 Mini",
    name2: "Airtime",
    name3: "1Gb",
    name4: "100Mb",
    name5: "Zawadi",
    name6: "Jinsi ya Kushiriki:",
    name7: "1. Chagua kadi moja unayopenda na undikike salamu",
    name8: "2. Share kadi kwa marafiki wako ili wailike",
    name9: "3. atakayepata likes zaidi atashinda iPhone 12 Mini",
    name10: "4. Ikiwa uko katika TOP 100 ， utapata zawadi moja",
    name11: "Orodha ya Cheo",
    name12: "Orodha ya Zawadi",
    name13:"TOP1",
    name14:"iPhone 12 Mini（64G）",
    name15:"Top 2-Top 10",
    name16:"",
    name17:"Top 11-Top 50",
    name18:"1Gb",
    name19:"Top 51-Top 100",
    name20:"100Mb",
    name21:"Kumbuka",
    name22:"Akaunti tu za Carlcare zinaweza kushiriki, ikiwa huna,tafadhali jiandikishe kwanza.",
    name23:"Ukifanikiwa kupata zawadi, tafadhali wasilisha maelezo yako ndani ya kipindi cha shughuli, kama si hivyo, hutapata zawadi. ",
    name24:" Ikiwa una shida yoyote, tafadhali wasiliana nasi: Carlcarelucky@gmail.com.",
    name25:"Carlcare ina haki ya kubadilisha tafsiri ya maelezo haya.",
    name26:"Krismasi Njema Barikiwa Kushinda iPhone",
    name27:"Krismasi Njema",
    name28:"Sheria ya Shughuli",
    name29:"Sawa",
    name30:"boresha",
    name31:"boresha ili kufurahiya shughuli :)",
    name32:"jisajili",
    name33:"Tafadhali jisajili kwanza",
    name34:"SHINDANO LIMEKWISHA",
    name35:"unayo",
    name36:"Likes",
    name37:"Baraka yangu",
    name38:"pata",
    name39:"cheo",
    name40:"kitambulisho",
    name41:"kanuni",
    name42:"Wewe ndiyo wa kwanza",
    name43:"kwa sasa,Hongera!!",
    name44:"Kadi",
    name45:"Tafadhali jaza maelezo kamili",
    name46:"Umefanikiwa kuwasilisha habari",
    name47:"Krismasi yenye fanaka-Pata pendo ushinde iPhone 12",
  },
};